import { useState, useEffect } from "react"
import {PlusCircleIcon, CakeIcon} from "@heroicons/react/24/solid";
import { updateSystemNotification, createSystemNotification, getAllSystemNotifications } from "../../util/db";

export default function PostSystemNotification() {
  const [isOpen, setisOpen] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [title, setTitle] = useState("")
  const [subtitle, setSubtitle] = useState("")
  const [successfullPost, setSuccessfullPost] = useState(false)
  const [visibility, setVisibility] = useState(false)
  const [notificationID, setNotificationID] = useState("")
  const [link, setLink] = useState("")
  const [linkText, setLinkText] = useState("")
  
  function closePopup() {
    setisOpen(false)
    setSuccessfullPost(false)
    setButtonDisabled(false)
  }
  async function updateDatabase() {
    setButtonDisabled(true)
    const data = { title, subtitle, visibility, link, linkText }
    if (notificationID) {
      await updateSystemNotification(notificationID, data)
    } else {
      const ref = await createSystemNotification(data)
      setNotificationID(ref.id)
    }
    setSuccessfullPost(true)
    setButtonDisabled(false)
  }

  useEffect(() => {
    async function fetchNotification() {
      const data = await getAllSystemNotifications()
      let notification
      if (data.length > 0) {
        notification = data[0]
      } else {
        return // TODO: error out here
      }
      if (notification?.id) {
        setNotificationID(notification?.id)
      }
      if (notification?.title) {
        setTitle(notification?.title)
      }
      if (notification?.subtitle) {
        setSubtitle(notification?.subtitle)
      }
      if (notification?.visibility) {
        setVisibility(notification?.visibility)
      }
      if (notification?.link) {
        setLink(notification.link)
      }
      if (notification?.linkText) {
        setLinkText(notification.linkText)
      }
    }
    fetchNotification();
  }, []);

  return (
    <>
    {(isOpen)&&(
      <div className="z-20 fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center">
        {/* Popup content */}
        <div className="bg-white p-8 rounded-lg shadow-lg lg:w-1/2 w-3/4 max-w-4xl relative">
          {successfullPost===true?(
            <div className="flex flex-col text-center space-y-4">
              <CakeIcon className='h-12 text-green-700'/>
              <h2 className='text-5xl font-semibold'>System Notification Updated Successfully</h2>
              <button onClick={()=> closePopup()} className=" absolute top-0 right-4 text-3xl text-gray-400 rounded-md">
              &times;
              </button>
            </div>
            ):(
              <>
              <h2 className=" text-center text-5xl font-bold pb-6">Update System Notification</h2>
              <p className='text-gray-600 text-center'>Please enter the relevant information before posting.</p>
              <button onClick={()=> closePopup()} className=" absolute top-0 right-4 text-3xl text-gray-400 rounded-md">
                &times;
              </button>

              <div className='h-0 my-4 border-t-4 border-dotted border-gray-200'></div>
              <p className='text-black-400 text-left m-2'>System Notification Title</p>
              <div className='mb-2'>
                <input
                  type="text"
                  name="title"
                  id="title"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder='Attention:'
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <p className='text-black-400 text-left m-2'>System Notification Subtitle</p>
              <div className='mb-2'>
                <input
                  name="subtitle"
                  id="subtitle"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder='Description'
                  value={subtitle}
                  onChange={(e) => setSubtitle(e.target.value)}
                />
              </div>
              <p className='text-black-400 text-left m-2'>Link URL</p>
              <div className='mb-2'>
                <input
                  type="url"
                  name="link"
                  id="link"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder='https://example.com'
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                />
              </div>
              <p className='text-black-400 text-left m-2'>Link Button Text</p>
              <div className='mb-2'>
                <input
                  type="text"
                  name="linkText"
                  id="linkText"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder='Register Now'
                  value={linkText}
                  onChange={(e) => setLinkText(e.target.value)}
                />
              </div>
              <div className="mb-4 flex items-center space-x-4">
                <span className="text-sm text-gray-700">Hidden</span>
                <button
                  type="button"
                  onClick={() => setVisibility(!visibility)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                    visibility ? "bg-green-600" : "bg-gray-300"
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      visibility ? "translate-x-6" : "translate-x-1"
                    }`}
                  />
                </button>
                <span className="text-sm text-gray-700">Visible</span>
              </div>
              <button onClick={()=>updateDatabase()} disabled={buttonDisabled} className="flex flex-row bg-green-600 text-gray-200 py-2 px-4 w-full justify-center rounded-md focus:outline-none focus:border-green-700">Upload System Notification</button>
              </>
            )}
        </div>
      </div>
    )}
    <button
        type="button"
        onClick={() => {setisOpen(true)}}
        className="relative flex flex-col items-center block min-w-[280px] rounded-lg border-2 border-dashed border-green-700 p-12 text-center hover:border-green-500 focus:outline-none text-green-700 hover:text-green-500 hover:bg-green-50"
    >
        <PlusCircleIcon className="h-12 justify-center "/>
        <span className="mt-2 block text-sm font-semibold text-gray-900">Update System Notification</span>
    </button>
    </>
  )
}